import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function SneakerGuidePage() {
  return <SeoArticleLayout article={seoArticles[1]} />;
}